import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { checkAuth, updateUser, saveToken } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        navigate('/login');
        return;
      }

      const sessionId = sessionIdMatch[1];
      
      // Get stored registration data
      const storedData = sessionStorage.getItem('signup_data');
      const signupData = storedData ? JSON.parse(storedData) : {};
      sessionStorage.removeItem('signup_data');

      try {
        const response = await fetch(`${API_URL}/api/auth/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({
            session_id: sessionId,
            marketing_consent: signupData.marketing_consent || false,
            phone: signupData.phone || null
          })
        });

        if (response.ok) {
          const data = await response.json();
          
          // Save session token to localStorage for persistence
          if (data.session_token) {
            saveToken(data.session_token);
          }
          
          // Update auth context with user data
          updateUser(data);
          
          // Refresh auth state
          await checkAuth();
          
          // Navigate to dashboard
          navigate('/dashboard', { replace: true });
        } else {
          console.error('Session exchange failed:', response.status);
          navigate('/login');
        }
      } catch (error) {
        console.error('Auth error:', error);
        navigate('/login');
      }
    };

    processAuth();
  }, [navigate, location, checkAuth, updateUser, saveToken]);

  return (
    <div className="min-h-screen bg-navy-900 flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-gold-400 animate-spin mx-auto mb-4" />
        <p className="text-white text-lg">Setting up your account...</p>
        <p className="text-gray-400 text-sm mt-2">Redirecting to OLQ Dashboard...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
